import clsx from "clsx";
import { getGradeColor, getGradeForeground } from "../form/runtimeModel";
import { resolveAssetGrade, resolveAssetStatus } from "./assetStatus";
import type { HuelleAsset } from "./planModel";
import "./huelleDetail.css";

export function AssetStatusBadge({
  asset,
  className,
  size = "sm",
}: {
  asset: HuelleAsset | null | undefined;
  className?: string;
  size?: "sm" | "md";
}) {
  const status = resolveAssetStatus(asset);
  const grade = resolveAssetGrade(asset);
  const gradeColor = grade != null ? getGradeColor(grade) : null;
  return (
    <span className={clsx("inline-flex items-center gap-1.5", className)}>
      <span
        className={clsx(gradeColor ? "huelle-status huelle-status--graded" : status.className, size === "md" && "huelle-status--md")}
        style={gradeColor ? { ["--huelle-grade" as string]: gradeColor } : undefined}
        title={grade != null ? `${status.hint} Note ${grade}.` : status.hint}
      >
        <span className="huelle-status__dot" aria-hidden />
        {status.label}
      </span>
      {grade != null ? (
        <span
          className="huelle-grade"
          style={{ ["--huelle-grade" as string]: gradeColor || undefined, color: getGradeForeground(grade) }}
          title={`Note ${grade}`}
        >
          Note {grade}
        </span>
      ) : null}
    </span>
  );
}
